/**
 * QuickStartCard — Fix-Agent Developer-Redesign (v2-final/developer.html)
 *
 * Ersetzt ApiKeyCard/CodeExamplesCard (v1 "Api-Key"-Header, ACCEPTANCE-Verstoss
 * "v2 base URL only"): zeigt den v2-Customer-API-Aufruf mit Bearer-Token
 * (API-Token aus der Tokens-Liste oben) gegen /api/v2/hotspots, exakt wie in
 * der Design-Vorlage. Kein neuer Endpoint — reines Dokumentationsbeispiel.
 *
 * 390px-Fix (P1): weisse Zeilenumbrueche statt "white-space:pre", damit der
 * curl-Befehl auf schmalen Viewports lesbar umbricht statt abgeschnitten zu
 * werden.
 */
import { useTranslation } from 'react-i18next'
import { API_V2_BASE_URL } from './ApiBaseUrlUsageCard'

const TOKEN_PLACEHOLDER = 'ht_live_…'

const EXAMPLE_REQUEST = `curl -H "Authorization: Bearer ${TOKEN_PLACEHOLDER}" \\
  ${API_V2_BASE_URL}/hotspots`

const EXAMPLE_RESPONSE = `# response (excerpt)
{ "data": [{
  "name": "tropical-burgundy-bear",
  "hnt_24h": 0.142, "gb_24h": 1.6,
  "rate_usd": 0.114, "status": "online"
}]}`

const codeStyle: React.CSSProperties = {
  margin: 0,
  padding: '12px 14px',
  background: 'var(--bg-elev)',
  border: '1px solid var(--border)',
  borderRadius: 10,
  fontSize: 12,
  fontFamily: 'ui-monospace, Consolas, monospace',
  lineHeight: 1.6,
  overflowX: 'auto',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
}

export function QuickStartCard() {
  const { t } = useTranslation('developer')

  return (
    <section className="card card-pad" data-testid="developer-quick-start" aria-label={t('quickStart.title')} style={{ marginBottom: 18 }}>
      <h2 style={{ margin: '0 0 10px', fontSize: 16, fontWeight: 600 }}>{t('quickStart.title')}</h2>
      <pre data-testid="quick-start-request" style={codeStyle}>{EXAMPLE_REQUEST}</pre>
      <pre data-testid="quick-start-response" style={{ ...codeStyle, marginTop: 8 }}>{EXAMPLE_RESPONSE}</pre>
      <p style={{ margin: '10px 0 0', fontSize: 12, color: 'var(--text-subtle)' }}>{t('quickStart.hint')}</p>
    </section>
  )
}
